import PassengerTnesService from 'js/services/api/passenger/tnes.js'

import template from './_tne-item.pug'

const AUTHORIZED_STATUS = 1

// @vue/component
export default {
  template: template(),
  props: {
    tne: {
      type: Object,
      default: () => ({})
    },
    mediaProfiles: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      alias: this.tneAlias,
      errors: {},
      editingAlias: false
    }
  },
  computed: {
    isAuthorized() {
      return this.tne.status === AUTHORIZED_STATUS
    },

    defaultAlias() {
      if (!this.tne.media_type) { return '' }

      return this.$t(`balance.mediaTypes.${this.tne.media_type}`)
    },

    tneAlias() {
      return this.tne.alias || this.defaultAlias
    },

    tneIcon() {
      if (this.isAuthorized) { return 'ns-icon-tne-accepted text-primary' }

      return 'ns-icon-tne-disabled text-danger'
    },

    notErrors() {
      return _.isEmpty(this.errors)
    }
  },
  watch: {
    tneAlias: {
      handler() { this.alias = this.tneAlias },
      immediate: true
    }
  },
  methods: {
    async updateTne(id, params) {
      this.cleanErrors()

      return PassengerTnesService.update(id, params).then(response => response).catch(response => {
        this.errors = response.data.errors
      })
    },

    async saveAlias() {
      const alias = this.alias || this.defaultAlias
      await this.updateTne(this.tne.id, {alias})

      if (this.notErrors) {
        this.$set(this.tne, 'alias', alias)
        this.toggleEditingAlias()
      }
    },

    toggleEditingAlias() {
      this.editingAlias = !this.editingAlias
    },

    cleanErrors() {
      this.errors = {}
    },

    deregisterTne() {
      this.$emit('deregister-tne', this.tne)
    }
  }
}
